import axios from 'axios';
import { useQuery } from 'react-query';

import errorHandler from '../../../helpers/errorHandler';

export default function useJobMapJobPosting(
  jobMapId,
  jobPostingId,
  serializerView,
  options = {}
) {
  return useQuery(
    ['job_map_job_posting', jobMapId, jobPostingId, serializerView],
    async () => {
      const res = await axios
        .get(
          window.Routes.api_job_map_job_posting_path(jobPostingId, {
            job_map_id: jobMapId,
            serializer_view: serializerView,
          })
        )
        .catch(errorHandler.handleError);
      if (options.onSuccess) options.onSuccess(res.data);

      return res ? res.data : {};
    }
  );
}
